import React, { FC } from 'react';

import { FormattedMessage } from 'react-intl';

import LaunchIcon from '@mui/icons-material/Launch';
import Switch from '@mui/material/Switch';

import CommonMessages from '~/core/commonMessages';
import { getDataLayer } from '~/core/googleAnalyticsUtils';
import { BettingOddPartner } from '~/core/types';

import {
    BettingOddsLogoLink,
    BettingOddsSwitch,
    BettingOddsSwitchLabel,
    BettingOddsToggle,
    OddsProviderContainer,
    OddsProviderLabel,
} from './styles';

type BettingOddsProps = {
    bettingOddPartner: BettingOddPartner;
    showToggle: boolean;
    hideBettingOdds?: boolean;
    toggleBettingOdds?: () => void;
};

const BettingOdds: FC<BettingOddsProps> = ({
    bettingOddPartner,
    showToggle,
    hideBettingOdds = false,
    toggleBettingOdds,
}) => {
    const onToggleClick = () => {
        if (toggleBettingOdds) {
            getDataLayer().push({
                event: 'odds_toggle_click',
                toggle_action: hideBettingOdds ? 'show' : 'hide',
            });

            toggleBettingOdds();
        }
    };

    return (
        // this check protects against the page crashing if there's no bettingOddPartner for a country
        bettingOddPartner && (
            <OddsProviderContainer $partner={bettingOddPartner}>
                <OddsProviderLabel $partner={bettingOddPartner}>
                    <FormattedMessage {...CommonMessages.gameInformationDescriptions.oddsBy} />
                </OddsProviderLabel>
                <BettingOddsLogoLink $partner={bettingOddPartner} href={bettingOddPartner.siteUrl} target="_blank">
                    <img src={bettingOddPartner.imageUrl} alt={bettingOddPartner.name} />
                    <LaunchIcon />
                </BettingOddsLogoLink>
                {showToggle && (
                    <BettingOddsToggle>
                        <BettingOddsSwitchLabel htmlFor="bettingOddSwitch" $partner={bettingOddPartner}>
                            <FormattedMessage
                                description="A toggle switch label, describing whether or not we should show odds"
                                defaultMessage="Hide"
                            />
                        </BettingOddsSwitchLabel>
                        <BettingOddsSwitch $partner={bettingOddPartner} $checked={hideBettingOdds}>
                            <Switch id="bettingOddSwitch" checked={hideBettingOdds} onClick={onToggleClick} />
                        </BettingOddsSwitch>
                    </BettingOddsToggle>
                )}
            </OddsProviderContainer>
        )
    );
};

export default BettingOdds;
